/* AVATAR COLORS */
export const avatarColors = {
    purple: '#7E22CE',
    rose: '#BE123C',
    yellow: '#A16207',
    blue: '#1D4ED8',
    emerald: '#047857',
    default: '#666666' /* default */
} as const;

// build types from object
export type FuelAvatarColorKey = keyof typeof avatarColors;
export type FuelAvatarColorValue = typeof avatarColors[FuelAvatarColorKey];

export const getAvatarColor = (
    avatarColor?: FuelAvatarColorKey
): FuelAvatarColorValue => {
    if (!avatarColor) {
        return avatarColors.default;
    }

    if (!(avatarColor in avatarColors)) {
        return avatarColors.default;
    }

    return avatarColors[avatarColor];
};
